function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import classnames from "classnames";
import { StyledSolutionsMenuComponent } from "./solutions-menu-component.scss";
import MenuDivider from "../components/menu-divider/menu-divider";
import { COMPANY_SIZE_LINKS, INDUSTRIES_LINKS, TEAMS_LINKS } from "./consts";
import DescriptiveLinkBlock from "../components/descriptive-link-block/descriptive-link-block";
import MiniLinkItem from "../components/mini-link-item/mini-link-item";
const SolutionsMenuComponent = ({ translate, onLinkClick, menuId })=>{
    const onLinkClickWithMenuId = (event, link, text)=>onLinkClick({
            menuId,
            link,
            event,
            text
        });
    return /*#__PURE__*/ _jsxs(StyledSolutionsMenuComponent, {
        className: "menu-component",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: classnames("section", "company-size-section"),
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: classnames("section-title", "align-to-link"),
                        children: "Company size"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: classnames("links", "company-links"),
                        children: COMPANY_SIZE_LINKS.map((_param, index)=>{
                            var { title, description, link } = _param, company = _object_without_properties(_param, [
                                "title",
                                "description",
                                "link"
                            ]);
                            return /*#__PURE__*/ _createElement(DescriptiveLinkBlock, _object_spread_props(_object_spread({
                                onClick: (event)=>onLinkClickWithMenuId(event, link, title),
                                title: translate(title),
                                link: link,
                                description: translate(description)
                            }, company), {
                                key: index
                            }));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(MenuDivider, {}),
            /*#__PURE__*/ _jsxs("div", {
                className: classnames("section", "teams-section"),
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: classnames("section-title", "align-to-link"),
                        children: "Teams"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: classnames("links", "teams-links-container"),
                        children: TEAMS_LINKS.map((_param, index)=>{
                            var { text, link } = _param, team = _object_without_properties(_param, [
                                "text",
                                "link"
                            ]);
                            return /*#__PURE__*/ _createElement(MiniLinkItem, _object_spread_props(_object_spread({
                                link: link,
                                onClick: (event)=>onLinkClickWithMenuId(event, link, text),
                                text: translate(text)
                            }, team), {
                                key: index
                            }));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(MenuDivider, {}),
            /*#__PURE__*/ _jsxs("div", {
                className: classnames("section", "industries-section"),
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: classnames("section-title", "align-to-link"),
                        children: "Industries"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "links",
                        children: INDUSTRIES_LINKS.map((_param, index)=>{
                            var { text, link } = _param, industry = _object_without_properties(_param, [
                                "text",
                                "link"
                            ]);
                            return /*#__PURE__*/ _createElement(MiniLinkItem, _object_spread_props(_object_spread({
                                link: link,
                                onClick: (event)=>onLinkClickWithMenuId(event, link, text),
                                text: translate(text)
                            }, industry), {
                                key: index
                            }));
                        })
                    })
                ]
            })
        ]
    });
};
export default SolutionsMenuComponent;
